<template>
  <div v-if="localeStore?.isUsLocale" class="accepted-payments mgn-top-1-pt5">
    <div class="ff-text-500 mgn-btm-pt5">{{ useTranslate('CartSlideout.paymentMethods') }}</div>
    <CloudinaryImage
      :public-id="`sbpcmgqeoxs0vbd4yjws`"
      :options="{ width: 443, quality: 'auto:eco' }"
      :alt="`accepted payment options`"
    />
  </div>
</template>

<script setup lang="ts">
import { useLocaleStore } from '~/store/locale';
const localeStore = useLocaleStore();
</script>

<style lang="scss" scoped>
.accepted-payments {
  color: $color-neutral-cool-900;
  font-size: 0.875rem;
  line-height: 1.5;
  img {
    max-width: 100%;
    height: auto;
    @include local-mixins.tablet {
      max-width: 500px;
    }
  }
}
</style>
